import { render } from "./SloganBar.vue?vue&type=template&id=aaa3b8ce&scoped=true"
import script from "./SloganBar.vue?vue&type=script&lang=js"
export * from "./SloganBar.vue?vue&type=script&lang=js"

import "./SloganBar.vue?vue&type=style&index=0&id=aaa3b8ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaa3b8ce"]])

export default __exports__